<!-- flp 360 info modal -->
<div tabindex="0" aria-label="country change logout confirmation popup"
    [config]="{ignoreBackdropClick: true, keyboard:false, backdrop:false}" bsModal #flp360InfoModalPopup="app-modal"
    class="modal modal--center fade bs-example">
    <div class="modal-dialog flp360-modal-dialog">
        <div class="modal-content p-2">
            <div class="modal-header py-2">
                <h2 class="modal-title pull-left flp360-title">{{'common.Important'|translate}}</h2>
            </div>
            <div class="modal-body">
                <div tabindex="0" role="heading" class="modal-title modal-warn">
                    {{'common.We are not going to use Google to log you into FLP360 anymore and we need you to set a new password Click OK to verify your identity with Google and set a new password.' | translate | translateKey}}
                </div>
                <br>
                <div class="text-center">{{'common.(You will only have to do this only once)'|translate}}</div>
            </div>
            <div class="text-center justify-content-center">
                <button role="button" aria-label="yes" type="button" (click)="logoutAndNavigateToFLP360()"
                    class="btn btn-primary"
                    id="modal-btn-no">{{'common.Login Now' | translate | translateKey}}</button>
            </div>
        </div>
    </div>
</div>
